<template>
    <div>
        <h3>Slide {{index+1}}</h3>
        <el-form-item :label="$t(`BANNERS.shops`)"  size="mini" :prop="`slides.${index}.shops`">
            <el-select v-model="slide.shops" placeholder="Select if you want to show slide to specific shop" size="mini" filterable multiple collapse-tags>
                <el-option
                  v-for="item in shops"
                  :key="item.id"
                  :label="item.name "
                  :value="item.id">
                    <img  style="height: inherit" :src="item.iconURL" />
                    <span class="ml-2">{{ item.name }}</span>
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item :label="$t(`BANNERS.image`)" size="mini" :prop="`slides.${index}.image`" :rules="{ required: true, message: 'Please upload image', trigger: ['blur', 'change'] }">
            <small>Image size should be minimum 1170x585px and maximum 1376x688px and 3MB size</small>
            <el-upload
            class="banner-uploader"
            :action="filestorageURL"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :thumbnail-mode="true"
            >
                <img v-if="slide.image" :src="getLink(slide.image)" class="banner">
                <i v-else class="el-icon-plus banner-uploader-icon"></i>
            </el-upload>

        </el-form-item>

        <h4>{{$t(`BANNERS.text`)}}</h4>

        <div v-for="(text, textIndex) in slide.texts" :key="textIndex+index">
            <el-form-item :label="$t(`BANNERS.texts.${textIndex}`)" size="mini">
            <el-input v-model="slide.texts[textIndex]"></el-input>
            </el-form-item>
        </div>

        <h4>{{$t(`BANNERS.link`)}}</h4>

        <div v-for="(link, linkIndex) in slide.link" :key="linkIndex+index">
            <el-form-item :label="$t(`BANNERS.links.${linkIndex}`)" size="mini" :prop="`slides.${index}.link.${linkIndex}`" :rules="{ required: true, message: 'Please enter link', trigger: ['blur', 'change'] }">
                <el-input v-model="slide.link[linkIndex]"></el-input>
            </el-form-item>
        </div> 
        <hr />
    </div>
</template>

<script>
export default {
    name: 'BannersSlide',
    props: {
        slide: Object,
        index: Number,
        shops: Array,
    },
    data(){
        return {
            filestorageURL: `${process.env.VUE_APP_LOCATION}/filestorage`
        }
    },
    created(){
        console.log("props slide", this.$props)
    },
    methods: { 
        getLink(link){
          if(link.includes("local.filestorage"))
              return link.replace("local.filestorage", this.filestorageURL)
          else return link
      },
      handleAvatarSuccess(res, file, filelist) {
          this.$emit('imageChanged', { 
              name: res.file,
              index: this.index
          })
      },
      beforeAvatarUpload(file) {
          return new Promise(async (resolve, reject) => {
              let validate = await this.validateImage(file) 
              let imagetype = this.imageTypeIsValid(file)
              if(validate && imagetype)
                  resolve(true)
              else reject(false)
          })
      },
      validateImage( imageFile) {
        return new Promise((resolve, reject) => {

          if(imageFile.size > 3145728){
              this.$store.commit('addAlert', {
                  title: 'Failed ',
                  type: 'danger',
                  body: 'Image size max 3MB'
              });
              resolve(false);
              return;
          }

          const fReader = new FileReader();
          fReader.readAsDataURL(imageFile);
          fReader.onload = (event) => {
              const image = new Image();
              image.src = event.target.result;
              setTimeout(() => {
                  if(!this.imageSizeIsValid(image)) {
                      this.$store.commit('addAlert', {
                          title: 'Failed ',
                          type: 'danger',
                          body: 'Image size should be minimum 1170x585px and maximum 1376x688px'
                      });
                      
                      resolve(false);
                      return;
                  }
                  resolve(true);
                  return;
              }, 0);
          }
        });
      },
      imageSizeIsValid(image) {
          if(image.width >= 1170 && image.width <= 1376 && image.height >= 585 && image.height <= 688) {
              return true;
          } else {
              return false;
          }
      },
      imageTypeIsValid({type}) {
          let result;
          if(type.match(/jpeg|jpg|png/)) {
              result = true;
          } else {
              result = false;
              this.$store.commit('addAlert', {
                  title: 'Failed ',
                  type: 'danger',
                  body: 'Type of image should be jpg or png'
              });
          }
          return result;
      }
    }
}
</script>

<style lang="scss" >
    .input-box-cont {
        display:flex;
        flex-direction: column;
        justify-content: space-between;    

        p {
            font-size: 1.05em;
        }
    }
    .image-parent {
        display: flex;
        justify-content: center;
    }
    .banner-uploader .el-upload, .el-upload.el-upload--text {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 100%;
    }
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .banner-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .banner-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100%;
        line-height: 300px;
        text-align: center;
    }
    .banner {
        width: 100%;
        display: block;
    }
    div.image-holder {
        width: 50%;
        height: 100%;
        border: dotted 2px black;
        display: flex;
        justify-content: center;
        align-self: stretch;
        min-height: 100px;
        align-items: center;
        &.placeholder {
            border: dotted #ced4da 2px;
        }
        &.invalid.dirty {
            border-color: red;
        }
        img {
            width: 100%;
        }
    }
</style>